module.exports = __webpack_public_path__ + "img/card-profile6-square.1f1f4900.jpg";